// トロフィーとテーマ。トロフィーは行動でもらえ、自分のマイページにだけ出る。
// ポイントは、ほかの人が反応してくれたときに1つ増える（自分の書き込みへの「それな」「なるほど」、自分の話題に書き込んでくれた人）。使い道はテーマだけ

export interface TrophyDef { id: string; name: string; how: string; steps: number[]; hidden?: boolean }
// steps が1つのものは、取ったら金。3つのものは、銅・銀・金
export const TROPHIES: TrophyDef[] = [
  { id: 'first', name: 'はじめの一声', how: '初めて書き込む', steps: [1] },
  { id: 'sorena', name: 'それな', how: '書き込みに「それな」をもらう', steps: [10, 100, 1000] },
  { id: 'naruhodo', name: 'なるほど', how: '書き込みに「なるほど」をもらう', steps: [10, 100, 1000] },
  { id: 'answer', name: '聞き上手', how: 'ほかの人の質問に答える', steps: [3, 10, 50] },
  { id: 'asker', name: '問いを立てる人', how: '自分の話題に、ほかの人が5人書き込む', steps: [1, 5, 20] },
  { id: 'across', name: '向こう側へ', how: '反対の立場に「なるほど」を付ける', steps: [3, 30, 100] },
  { id: 'arena', name: '議論場デビュー', how: '議論場で討論を最後までやる', steps: [1] },
  { id: 'days', name: '常連', how: '書き込んだ日が増える', steps: [10, 30, 100] },
  { id: 'switch', name: '考え直す人', how: '同じ話題で、別の立場からも書き込む', steps: [1], hidden: true },
  { id: 'night', name: '夜ふかし', how: '夜中の2時から4時に書き込む', steps: [1], hidden: true },
  { id: 'morning', name: '早起き', how: '朝の5時から7時に書き込む', steps: [1], hidden: true },
];
export const TIER_NAME = ['', '銅', '銀', '金'];

// 数から段階を出す（0 まだ・1 銅・2 銀・3 金）
export function tierOf(def: TrophyDef, n: number): number {
  if (def.steps.length === 1) return n >= def.steps[0] ? 3 : 0;
  return def.steps.filter(s => n >= s).length;
}

export interface SkinDef { id: string; name: string; price: number; bg: string; text: string; accent: string; font?: string }
// 色の本体は style.css の [data-skin]。ここの色は一覧の見本に使う
export const SKINS: SkinDef[] = [
  { id: 'shinya', name: '深夜', price: 50, bg: '#121a2e', text: '#dfe4f2', accent: '#f0c75e' },
  { id: 'washi', name: '和紙', price: 100, bg: '#f4efe3', text: '#1e1b16', accent: '#9c2f22', font: 'Shippori+Mincho:wght@400;700' },
  { id: 'kokuban', name: '黒板', price: 100, bg: '#22392f', text: '#eef0e6', accent: '#f2d675', font: 'Zen+Maru+Gothic:wght@400;700' },
  { id: 'hougan', name: '方眼ノート', price: 150, bg: '#fdfdfb', text: '#1f2430', accent: '#1f55c4', font: 'Klee+One:wght@400;600' },
];
export function skinFontUrl(id: string | null | undefined): string | null {
  const f = SKINS.find(s => s.id === id)?.font;
  return f ? `https://fonts.googleapis.com/css2?family=${f}&display=swap` : null;
}
